import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export interface AddCaseHearingInput {
  clientId: string;
  matterId: string;
  title: string;
  hearingDate: string;
  forum?: string;
  notes?: string;
}

export interface AddCaseHearingResult {
  success: true;
  hearingId: string;
  eventId: string;
  matterId: string;
}

export const addCaseHearingCallable = httpsCallable<AddCaseHearingInput, AddCaseHearingResult>(
  functions,
  "addCaseHearing",
);

export interface AddCaseExpenseInput {
  clientId: string;
  matterId: string;
  label: string;
  amount: number;
  currency?: string;
  recoverability?: string;
}

export interface AddCaseExpenseResult {
  success: true;
  expenseId: string;
  matterId: string;
  wipValue: number;
}

export const addCaseExpenseCallable = httpsCallable<AddCaseExpenseInput, AddCaseExpenseResult>(
  functions,
  "addCaseExpense",
);

export interface UpdateContractLifecycleInput {
  clientId: string;
  matterId: string;
  lifecycleStage: string;
  renewalModel?: string;
  note?: string;
}

export interface UpdateContractLifecycleResult {
  success: true;
  eventId: string;
  matterId: string;
  lifecycleStage: string;
}

export const updateContractLifecycleCallable = httpsCallable<UpdateContractLifecycleInput, UpdateContractLifecycleResult>(
  functions,
  "updateContractLifecycle",
);

export interface CreateContractAmendmentMatterInput {
  clientId: string;
  parentMatterId: string;
  title: string;
}

export interface CreateContractAmendmentMatterResult {
  success: true;
  matterId: string;
  contractId: string;
  matterPath: string;
  parentMatterId: string;
}

export const createContractAmendmentMatterCallable = httpsCallable<
  CreateContractAmendmentMatterInput,
  CreateContractAmendmentMatterResult
>(functions, "createContractAmendmentMatter");

export interface UploadCaseEvidenceDocumentInput {
  clientId: string;
  matterId: string;
  name: string;
  type?: string;
  excerpt?: string;
  size?: string;
}

export interface UploadCaseEvidenceDocumentResult {
  success: true;
  documentId: string;
  insightId: string;
  evidenceState: string;
  matterId: string;
}

export const uploadCaseEvidenceDocumentCallable = httpsCallable<
  UploadCaseEvidenceDocumentInput,
  UploadCaseEvidenceDocumentResult
>(functions, "uploadCaseEvidenceDocument");

export interface UpdateCaseEvidenceStateInput {
  clientId: string;
  matterId: string;
  documentId: string;
  evidenceState: string;
  note?: string;
}

export interface UpdateCaseEvidenceStateResult {
  success: true;
  documentId: string;
  evidenceState: string;
  matterId: string;
}

export const updateCaseEvidenceStateCallable = httpsCallable<
  UpdateCaseEvidenceStateInput,
  UpdateCaseEvidenceStateResult
>(functions, "updateCaseEvidenceState");

export interface CloseCaseMatterInput {
  clientId: string;
  matterId: string;
  closureStatus: "SETTLED" | "WITHDRAWN" | "CLOSED";
  note?: string;
}

export interface CloseCaseMatterResult {
  success: true;
  matterId: string;
  closureStatus: string;
  knowledgeCandidateId: string;
}

export const closeCaseMatterCallable = httpsCallable<CloseCaseMatterInput, CloseCaseMatterResult>(
  functions,
  "closeCaseMatter",
);

export interface CreateCaseAppealMatterInput {
  clientId: string;
  parentMatterId: string;
  title: string;
}

export interface CreateCaseAppealMatterResult {
  success: true;
  matterId: string;
  caseId: string;
  matterPath: string;
  appellateParentId: string;
}

export const createCaseAppealMatterCallable = httpsCallable<
  CreateCaseAppealMatterInput,
  CreateCaseAppealMatterResult
>(functions, "createCaseAppealMatter");

export interface RecordContractDocumentRoleInput {
  clientId: string;
  matterId: string;
  name: string;
  documentRole: string;
}

export interface RecordContractDocumentRoleResult {
  success: true;
  documentId: string;
  documentRole: string;
  matterId: string;
}

export const recordContractDocumentRoleCallable = httpsCallable<
  RecordContractDocumentRoleInput,
  RecordContractDocumentRoleResult
>(functions, "recordContractDocumentRole");

export interface GenerateContractObligationsRegisterInput {
  clientId: string;
  matterId: string;
  obligations?: Array<{ title: string; dueAt?: string; triggerType?: string; assignedTo?: string }>;
}

export interface GenerateContractObligationsRegisterResult {
  success: true;
  matterId: string;
  obligationIds: string[];
  eventId: string;
}

export const generateContractObligationsRegisterCallable = httpsCallable<
  GenerateContractObligationsRegisterInput,
  GenerateContractObligationsRegisterResult
>(functions, "generateContractObligationsRegister");

export interface ExecuteContractMatterInput {
  clientId: string;
  matterId: string;
}

export interface ExecuteContractMatterResult {
  success: true;
  matterId: string;
  lifecycleStage: string;
  eventId: string;
}

export const executeContractMatterCallable = httpsCallable<ExecuteContractMatterInput, ExecuteContractMatterResult>(
  functions,
  "executeContractMatter",
);
